import React, { useState } from 'react';
import Modal from './components/modal/modal';
import { ModalVariant } from './components/modal/modal.constants';
import log from '../../../utils/log';
import { ModalContext } from './hooks/modal-provider.hook';

export interface OpenModalOptions {
  message: string,
  variant: ModalVariant,
  handleCloseModal?: any,
  onConfirmClick?: any,
  title?: string,
  secondMessage?: string
}

const ModalProvider = (props: any) => {

  const [modalMessage, setModalMessage] = useState<string | null>(null)
  const [modalTitle, setModalTitle] = useState<string | undefined>(undefined)
  const [modalSecondMessage, setModalSecondMessage] = useState<string | undefined>(undefined)
  const [modalVariant, setModalVariant] = useState<ModalVariant>(ModalVariant.Success)
  const [handleCloseModal, setHandleCloseModal] = useState<any>(() => () => null)
  const [onConfirmClick, setOnConfirmClick] = useState<any>(() => () => null)

  const openModal = (openModalOptions: OpenModalOptions) => {
    setModalMessage(openModalOptions.message)
    if (openModalOptions.title) {
      setModalTitle(openModalOptions.title)
    }
    if (openModalOptions.secondMessage) {
      setModalSecondMessage(openModalOptions.secondMessage)
    }
    setModalVariant(openModalOptions.variant)
    openModalOptions.handleCloseModal && setHandleCloseModal(() => openModalOptions.handleCloseModal)
    openModalOptions.onConfirmClick && setOnConfirmClick(() => openModalOptions.onConfirmClick)
  };

  const closeModal = () => {
    setModalMessage(null)
    handleCloseModal()
    setHandleCloseModal(() => () => null)
    setModalTitle(undefined)
    setModalSecondMessage(undefined)
    setOnConfirmClick(() => () => null)
  };

  const handleConfirmClick = (data?: any) => {
    onConfirmClick(data)
    closeModal()
  }

  return (
    <ModalContext.Provider value={{openModal}}>
      {props.children}
      <Modal
        secondMessage={modalSecondMessage}
        title={modalTitle}
        variant={modalVariant}
        message={modalMessage}
        handleClose={closeModal}
        onConfirmClick={handleConfirmClick}
      />
    </ModalContext.Provider>
  );
};

export default ModalProvider;
